import React from 'react';
import CheckmarkIcon from './checkmark-icon';
import { Box, Typography, useTheme } from '@mui/material';

interface YouDeserveItemProps {
  title: string;
  content: string;
}

const YouDeserveItem = ({
  title,
  content,
}: YouDeserveItemProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="row" marginBottom={3.5} component="li">
      <CheckmarkIcon />
      <Box display="flex" flexDirection="column" marginLeft={2}>
        <Typography marginBottom={2} variant="bodyBlack">
          {title}
        </Typography>
        <Typography color={theme.palette.neutral.dark} variant="body">
          {content}
        </Typography>
      </Box>
    </Box>
  );
};

export default YouDeserveItem;
